import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userSlice from './Slices/userSlice'
import appSlice from './Slices/appSlice'
// ...
const rootReducer = combineReducers({
  user: userSlice,
  app: appSlice
})
export const store = configureStore({
  reducer: rootReducer
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch